export function isIOS(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent)
        || /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}